export default {
  mainTitle: 'ECONOMIZE no seu carro por assinatura',
  mainSubtitle: 'Compare todos os sites de carros por assinatura de uma só vez!',
  seeOffer: 'Ver oferta',
  offerSelectedWaring: 'Você selecionou a seguinte oferta:',
  documentFormWaring:
    'Atencão! Documentos, informações e comprovantes precisam ser da pessoa quer irá assinar o contrato com a'
}
